import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	atlassianIntelligenceHeading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.atlassian-intelligence-heading',
		defaultMessage: 'Quick self-service with the power of AI',
		description:
			'Heading for section containing information about the virtual service agent AI answers.',
	},
	atlassianIntelligenceSubheadingV2: {
		id: 'servicedesk-settings-virtual-agent-landing.details.atlassian-intelligence-subheading-v-2',
		defaultMessage:
			'Connect your virtual service agent to your knowledge base, and let Atlassian Intelligence answer common questions in seconds.',
		description: 'AI answers subheading explaining what AI answers is.',
	},
	atlassianIntelligenceSubheading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.atlassian-intelligence-subheading',
		defaultMessage:
			'Connect your virtual agent to your knowledge base, and let Atlassian Intelligence answer common questions in seconds.',
		description: 'AI answers subheading explaining what AI answers is.',
	},
	atlassianIntelligenceButton: {
		id: 'servicedesk-settings-virtual-agent-landing.details.atlassian-intelligence-button',
		defaultMessage: 'Discover Atlassian Intelligence answers',
		description: 'Button for users to read more about the virtual service agent AI answers.',
	},
	atlassianIntelligenceImageAltText: {
		id: 'servicedesk-settings-virtual-agent-landing.details.atlassian-intelligence-image-alt-text',
		defaultMessage: 'Example of AI answers',
		description: 'Alternative text for AI answers image.',
	},
	atlassianIntelligenceLozengeText: {
		id: 'servicedesk-settings-virtual-agent-landing.details.atlassian-intelligence-lozenge-text',
		defaultMessage: 'Beta',
		description: 'Lozenge text to signify this feature is in beta.',
	},
	flowBuilderHeading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.flow-builder-heading',
		defaultMessage: 'Simple yet powerful flow builder',
		description:
			'Heading for section containing information about the virtual service agent flow builder.',
	},
	flowBuilderSubheading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.flow-builder-subheading',
		defaultMessage:
			'Create turn-by-turn conversations to answer questions, and automate more complicated tasks using web requests.',
		description: 'Flow builder subheading explaining what the flow builder is.',
	},
	flowBuilderButton: {
		id: 'servicedesk-settings-virtual-agent-landing.details.flow-builder-button',
		defaultMessage: 'Discover the conversation flow builder',
		description: 'Button for users to read more about the Vvirtual service agent flow builder.',
	},
	flowBuilderImageAltText: {
		id: 'servicedesk-settings-virtual-agent-landing.details.flow-builder-image-alt-text',
		defaultMessage: 'Example of flow builder',
		description: 'Alternative text for flow builder image.',
	},
	intentTemplatesHeading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.intent-templates-heading',
		defaultMessage: 'Customized intent templates, ready to go',
		description:
			'Heading for section containing information about the virtual service agent intent templates.',
	},
	intentTemplatesSubheading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.intent-templates-subheading',
		defaultMessage:
			'Get started fast with intent templates based on your project’s data, or pick a template from our catalog.',
		description: 'Intent templates subheading explaining what intent templates are.',
	},
	intentTemplatesButton: {
		id: 'servicedesk-settings-virtual-agent-landing.details.intent-templates-button',
		defaultMessage: 'Find out more about intents',
		description: 'Button for users to read more about the virtual service agent intent templates.',
	},
	intentTemplatesImageAltText: {
		id: 'servicedesk-settings-virtual-agent-landing.details.intent-templates-image-alt-text',
		defaultMessage: 'Example of intent templates',
		description: 'Alternative text for intent templates image.',
	},
	multipleChannelHeading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.multiple-channel-heading',
		defaultMessage: 'Ready to help, wherever your customers are',
		description:
			'Heading for section containing information about channel support in the virtual service agent.',
	},
	multipleChannelSubheadingV2: {
		id: 'servicedesk-settings-virtual-agent-landing.details.multiple-channel-subheading-v-2',
		defaultMessage:
			'Use the virtual service agent on Slack or in your portal, with support for more platforms on the way.',
		description: 'Subheading for channel section explaining what channels are available.',
	},
	multipleChannelSubheading: {
		id: 'servicedesk-settings-virtual-agent-landing.details.multiple-channel-subheading',
		defaultMessage:
			'Use the virtual agent on Slack or in your portal, with support for more platforms on the way.',
		description: 'Subheading for channel section explaining what channels are available.',
	},
	multipleChannelButtonV2: {
		id: 'servicedesk-settings-virtual-agent-landing.details.multiple-channel-button-v-2',
		defaultMessage: 'Find out how to set up your virtual service agent',
		description:
			'Button for users to read more about the multiple channel support in the virtual service agent.',
	},
	multipleChannelButton: {
		id: 'servicedesk-settings-virtual-agent-landing.details.multiple-channel-button',
		defaultMessage: 'Find out how to set up your virtual agent',
		description:
			'Button for users to read more about the multiple channel support in the Virtual Agent.',
	},
	multipleChannelImageAltText: {
		id: 'servicedesk-settings-virtual-agent-landing.details.multiple-channel-image-alt-text',
		defaultMessage: 'Example of multiple channels being supported',
		description: 'Alternative text for mutliple channel support image.',
	},
});
